import React from "react";
import { lang } from '@umu/ukit-lang';
import './uploadIntroductionTableTitle.scss';

function UploadIntroductionTableTitle(){
	return <div className="upload-introduction-table-title">{lang('导师管理信息表')}</div>;
}

export default UploadIntroductionTableTitle;